import * as React from "react";
import {
  Grid,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { getHeaders } from "../utils/HeaderHelper";
import { AuthenticationContext } from "../Context";
import { formatToUsDate, getDateTime } from "../utils/DateHelper";

interface Props {
  claimId: string;
  showClaimHistory: boolean;
  closeShowClaimHistoryModal: any;
}

const ClaimHistory: React.FC<Props> = ({
  claimId,
  showClaimHistory,
  closeShowClaimHistoryModal,
}) => {
  const authenticationSetting = React.useContext(AuthenticationContext);
  const [claimLogs, setClaimLogs] = React.useState([]);

  const fetchClaimLogHistory = () => {
    fetch(`/billing/claims/${claimId}/claim_logs`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (!result.success) {
          console.log(result.error);
        } else {
          console.log("result", result);
          setClaimLogs(result.resource);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    fetchClaimLogHistory();
  }, [claimId]);

  return (
    <Modal
      open={showClaimHistory}
      className={"modal-primary"}
      onClose={closeShowClaimHistoryModal}
    >
      <div className="paper" style={{ width: "950px", height: "90vh" }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className={`main-header`} style={{ marginBottom: "0px" }}>
                <span>Claim History</span>
                <span id="dismiss-button" onClick={closeShowClaimHistoryModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="content" style={{ padding: "0 0 40px 0" }}>
                <TableContainer sx={{ height: "75vh" }}>
                  <Table stickyHeader>
                    <TableHead
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor: "#fff",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      <TableRow
                        sx={{
                          "& td, & th": {
                            borderBottom: "none",
                          },
                        }}
                      >
                        <TableCell
                          align="left"
                          sx={{ paddingLeft: "40px", width: "165px" }}
                        >
                          Date
                        </TableCell>
                        <TableCell align="left" sx={{ width: "180px" }}>
                          Actor
                        </TableCell>
                        <TableCell align="left" sx={{ paddingRight: "40px" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {claimLogs?.map((claimLog) => (
                        <TableRow
                          sx={{ "& td, & th": { borderBottom: "none" } }}
                        >
                          <TableCell
                            align="left"
                            sx={{ paddingLeft: "40px", width: "165px" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                columnGap: "18px",
                              }}
                            >
                              <span>{formatToUsDate(claimLog.created_at)}</span>
                              <span>{getDateTime(claimLog.created_at)}</span>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ width: "180px" }}>
                            {claimLog.actor}
                          </TableCell>
                          <TableCell align="left" sx={{ paddingRight: "40px" }}>
                            {claimLog.description}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default ClaimHistory;
